import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router';
import { toast } from 'react-toastify';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import singleSpaReact from 'single-spa-react';
import { injectSnowplow, initialize } from './actions';
import App from './containers/App';
import reducers from './reducers';
import { StoreState } from './types';
import history from './history';
import { clearInvalidCookies, getConfig } from './utils';
import '@built/design-system/index.css';
import '@built/built-components/build/index.css';
import './index.scss';
import { IE11Screen } from './components/IE11Screen';
import { composeWithDevTools } from '@redux-devtools/extension';

export const Root = () => {
  clearInvalidCookies();

  if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
    return (
      <Router history={history}>
        <Route component={IE11Screen} />
      </Router>
    );
  }

  // Call it once in your app. At the root of your app is the best place
  toast.configure();

  const store = createStore<StoreState>(
    // TODO: remove the any cast when redux typings can handle strict TS flags
    // tslint:disable-next-line:no-any
    combineReducers({ ...reducers } as any),
    composeWithDevTools(applyMiddleware(thunk))
  );

  store.dispatch(initialize());

  return (
    <Provider store={store}>
      <Router history={history}>
        <Route component={App} />
      </Router>
    </Provider>
  );
};

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    // TODO: Replace with standarized error component;
    return <div>Error</div>;
  }
});

export const { bootstrap, unmount } = lifecycles;
export const mount = [
  lifecycles.mount,
  async () => {
    try {
      // This will be shown if an incident or maintenance is posted on our
      // status page; for instance, if login or cognito is down
      var scriptElm = document.createElement('script');
      scriptElm.src = 'https://status.getbuilt.com/embed/script.js';
      document.body.appendChild(scriptElm);
    } catch (error) {
      console.error(error, {
        message: 'App failed to initialize status widget'
      });
    }
  }
];
